import React from 'react';
import Select from 'react-select';
import Button from '../../components/Button';
import Tooltip from '../../components/Tooltip';
import { DARWIN_NAVY } from '../../constants';

const Sidebar = ({
  categories,
  clientsLoading,
  categoriesLoading,
  clientsError,
  categoriesError,
  selectedCategory,
  setSelectedCategory,
  dropdownOpts,
  selectedClient,
  setSelectedClient,
  clients,
  setCreateMode,
  fetchCategories,
}) => {
  const onClick = (category) => {
    setSelectedCategory(category);
    setCreateMode(false);
  };

  let Display = null;

  if (clientsLoading) {
    Display = (
      <div className="d-flex align-items-center justify-content-center flex-column mt-2">
        <div>Fetching clients...</div>
        <div className="sidebar-loader" />
      </div>
    );
  }

  if (clientsError) {
    Display = <div>Error fetching clients.</div>;
  }

  if (clients.length) {
    Display = (
      <>
        <div className="d-flex align-items-center pl-2">
          <UserIcon />
          <Select
            options={Array.from(dropdownOpts)}
            onChange={(selected) => setSelectedClient(selected)}
            value={selectedClient}
            styles={{
              control: (styles) => ({
                ...styles,
                border: 'none',
              }),
              container: (provided) => ({
                ...provided,
                flexGrow: 1,
                marginLeft: '1rem',
                fontSize: '1.2rem',
              }),
              singleValue: (styles) => ({
                ...styles,
                color: DARWIN_NAVY,
              }),
            }}
          />
        </div>
        <div className="section-title d-flex justify-content-between">
          {selectedClient && (
            <>
              <div className="d-flex align-items-center">
                Easy AI Categories
              </div>
              <div className="d-flex">
                <Tooltip content="Create Easy AI category">
                  <div>
                    <Button
                      className="create-new"
                      disabled={categoriesLoading}
                      onClick={() => setCreateMode(true)}
                      appearance="subtle"
                    >
                      <i className="fa-solid fa-plus" />
                    </Button>
                  </div>
                </Tooltip>
                <Tooltip content="Refresh categories">
                  <div>
                    <Button
                      className="create-new ml-1"
                      onClick={fetchCategories}
                      appearance="subtle"
                    >
                      <i className="fa-solid fa-rotate-right" />
                    </Button>
                  </div>
                </Tooltip>
              </div>
            </>
          )}
        </div>
        {categoriesLoading ? (
          <div className="mt-3 d-flex justify-content-center align-items-center">
            <div className="sidebar-loader" />
          </div>
        ) : categoriesError ? (
          <div className="mt-3">Error fetching categories.</div>
        ) : (
          <>
            <ul>
              {categories.map((category) => {
                return (
                  <ListItem {...{ category, selectedCategory, onClick }} />
                );
              })}
            </ul>
          </>
        )}
      </>
    );
  }

  return <div className="easy-ai-manager__sidebar">{Display}</div>;
};

export default Sidebar;

const ListItem = ({ category, selectedCategory, onClick }) => {
  const selected = category === selectedCategory;

  return (
    <div
      className={`category-list__item-container ${selected ? 'selected' : ''}`}
    >
      <div className={`category-list__item`} onClick={() => onClick(category)}>
        {category.category_name}
        {category.status_locked && (
          <Tooltip
            content="Someone on your team has finalized this prompt."
            className="easy-ai-lock-tooltip"
          >
            <div className="locked">
              <i className="fa fa-lock" />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

const UserIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7895 0.315918C5.26947 0.315918 0.789474 4.79592 0.789474 10.3159C0.789474 15.8359 5.26947 20.3159 10.7895 20.3159C16.3095 20.3159 20.7895 15.8359 20.7895 10.3159C20.7895 4.79592 16.3095 0.315918 10.7895 0.315918ZM10.7895 4.31592C12.7195 4.31592 14.2895 5.88592 14.2895 7.81592C14.2895 9.74592 12.7195 11.3159 10.7895 11.3159C8.85947 11.3159 7.28947 9.74592 7.28947 7.81592C7.28947 5.88592 8.85947 4.31592 10.7895 4.31592ZM10.7895 18.3159C8.75947 18.3159 6.35947 17.4959 4.64947 15.4359C6.4013 14.0621 8.56323 13.3155 10.7895 13.3155C13.0157 13.3155 15.1777 14.0621 16.9295 15.4359C15.2195 17.4959 12.8195 18.3159 10.7895 18.3159Z"
      fill="#1E2B4E"
    />
  </svg>
);

export const EasyAiIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.70048 2.9495C4.79146 2.49266 5.01222 2.07174 5.3363 1.73715C5.66039 1.40255 6.07406 1.16848 6.52777 1.06297C6.98148 0.957458 7.45599 0.984979 7.89446 1.14224C8.33293 1.29949 8.71677 1.57982 9 1.94963C9.28323 1.57982 9.66707 1.29949 10.1055 1.14224C10.544 0.984979 11.0185 0.957458 11.4722 1.06297C11.9259 1.16848 12.3396 1.40255 12.6637 1.73715C12.9878 2.07174 13.2085 2.49266 13.2995 2.9495L13.4245 3.57642L13.8305 3.65741C14.4419 3.78005 14.992 4.1106 15.3874 4.59288C15.7827 5.07517 15.9989 5.67945 15.9992 6.30306V6.50104C15.9992 7.22694 15.6892 7.88086 15.1943 8.3378C15.7988 8.63735 16.2951 9.11775 16.6141 9.71226C16.9331 10.3068 17.059 10.9859 16.9743 11.6552C16.8897 12.3246 16.5986 12.9509 16.1417 13.4473C15.6847 13.9437 15.0845 14.2854 14.4244 14.425L14.3874 14.61C14.2722 15.1864 13.9887 15.7157 13.5727 16.131C13.1567 16.5463 12.627 16.829 12.0504 16.9433C11.4738 17.0576 10.8762 16.9983 10.3333 16.7731C9.79035 16.5479 9.32637 16.1667 9 15.6778C8.67363 16.1667 8.20965 16.5479 7.66671 16.7731C7.12376 16.9983 6.52623 17.0576 5.94963 16.9433C5.37304 16.829 4.84327 16.5463 4.42729 16.131C4.01132 15.7157 3.72781 15.1864 3.61261 14.61L3.57561 14.425C2.91552 14.2854 2.3153 13.9437 1.85833 13.4473C1.40136 12.9509 1.11033 12.3246 1.02567 11.6552C0.941012 10.9859 1.06693 10.3068 1.38592 9.71226C1.70492 9.11775 2.20115 8.63735 2.8057 8.3378C2.55199 8.10379 2.3495 7.81979 2.21097 7.50367C2.07244 7.18756 2.00088 6.84618 2.00079 6.50104V6.30306C2.00108 5.67945 2.21727 5.07517 2.61262 4.59288C3.00797 4.1106 3.5581 3.78005 4.16954 3.65741L4.5755 3.57742L4.70048 2.9495ZM12.9995 9.91559V10.5005C12.9995 10.8983 12.8415 11.2798 12.5603 11.561C12.279 11.8423 11.8975 12.0003 11.4997 12.0003H9.49994V14.0271C9.50077 14.516 9.68316 14.9872 10.0117 15.3494C10.3403 15.7115 10.7917 15.9387 11.2783 15.9869C11.7649 16.035 12.252 15.9008 12.6452 15.6102C13.0385 15.3196 13.3098 14.8933 13.4065 14.414L13.5095 13.9021C13.5289 13.8054 13.5764 13.7165 13.6462 13.6468C13.7159 13.5771 13.8047 13.5295 13.9014 13.5101L14.1924 13.4511C14.7245 13.3433 15.1996 13.0465 15.5299 12.6155C15.8601 12.1846 16.0233 11.6488 15.9891 11.1069C15.955 10.5651 15.7259 10.0539 15.3442 9.66786C14.9624 9.2818 14.4539 9.04695 13.9124 9.00671C13.8374 9.21651 13.7165 9.40693 13.5585 9.56415C13.4006 9.72137 13.2097 9.84142 12.9995 9.91559ZM11.9997 9.91559C11.7632 9.83179 11.5516 9.69001 11.3841 9.50325C11.2166 9.31648 11.0987 9.0907 11.041 8.84655C10.9834 8.60241 10.9879 8.34771 11.0542 8.10577C11.1204 7.86382 11.2463 7.64237 11.4203 7.46167C11.5943 7.28097 11.8109 7.1468 12.0502 7.07144C12.2894 6.99608 12.5438 6.98193 12.7899 7.0303C13.0361 7.07868 13.2662 7.18801 13.4591 7.34831C13.6521 7.50861 13.8018 7.71474 13.8944 7.94785C14.2118 7.86123 14.4919 7.67268 14.6915 7.41124C14.8912 7.14981 14.9993 6.82999 14.9993 6.50104V6.30306C14.9993 5.49317 14.4284 4.79726 13.6345 4.63828L12.9016 4.4913C12.8049 4.47192 12.716 4.42436 12.6463 4.35462C12.5765 4.28488 12.529 4.19606 12.5096 4.09935L12.3186 3.14548C12.2501 2.79847 12.0547 2.48944 11.7706 2.27867C11.4865 2.06789 11.1341 1.97049 10.7821 2.00545C10.4301 2.04041 10.1038 2.20523 9.86674 2.46777C9.62968 2.7303 9.49891 3.07172 9.49994 3.42544V11.0005H11.4997C11.6323 11.0005 11.7595 10.9478 11.8532 10.854C11.947 10.7603 11.9997 10.6331 11.9997 10.5005V9.91559ZM8.50006 5.00123V3.42444C8.50083 3.07081 8.36989 2.72956 8.13275 2.46722C7.89561 2.20488 7.56927 2.04024 7.21736 2.00541C6.86544 1.97058 6.51316 2.06805 6.22919 2.27882C5.94523 2.48959 5.74993 2.79855 5.68137 3.14548L5.49139 4.09935C5.47194 4.1962 5.42424 4.28511 5.3543 4.35486C5.28437 4.42462 5.19533 4.4721 5.09844 4.4913L4.36552 4.63828C3.98083 4.7156 3.63473 4.92364 3.38596 5.22708C3.13719 5.53052 3.00106 5.91068 3.00067 6.30306V6.50104C3.00067 6.89881 3.15869 7.28029 3.43997 7.56156C3.72124 7.84283 4.10273 8.00084 4.50051 8.00084H5.50039C5.89817 8.00084 6.27966 8.15886 6.56093 8.44012C6.84221 8.72139 7.00023 9.10287 7.00023 9.50065V10.0856C7.33379 10.2035 7.61493 10.4356 7.79395 10.7407C7.97297 11.0459 8.03834 11.4045 7.97851 11.7532C7.91868 12.1019 7.73751 12.4182 7.467 12.6463C7.1965 12.8743 6.85408 12.9994 6.50028 12.9994C6.14648 12.9994 5.80406 12.8743 5.53356 12.6463C5.26306 12.4182 5.08188 12.1019 5.02205 11.7532C4.96222 11.4045 5.02759 11.0459 5.20661 10.7407C5.38563 10.4356 5.66677 10.2035 6.00034 10.0856V9.50065C6.00034 9.36806 5.94766 9.24089 5.85391 9.14714C5.76015 9.05338 5.63299 9.00071 5.50039 9.00071H4.24853C3.69189 9.00232 3.15563 9.21042 2.74362 9.58471C2.3316 9.959 2.07312 10.4729 2.01824 11.0268C1.96335 11.5807 2.11597 12.1353 2.44652 12.5832C2.77708 13.031 3.26207 13.3403 3.80758 13.4511L4.09855 13.5101C4.19526 13.5295 4.28408 13.5771 4.35382 13.6468C4.42357 13.7165 4.47113 13.8054 4.49051 13.9021L4.5935 14.414C4.69023 14.8933 4.96153 15.3196 5.35476 15.6102C5.748 15.9008 6.23515 16.035 6.72174 15.9869C7.20833 15.9387 7.65968 15.7115 7.98826 15.3494C8.31684 14.9872 8.49923 14.516 8.50006 14.0271V6.0011H7.91512C7.79719 6.33467 7.56513 6.6158 7.25996 6.79482C6.95478 6.97383 6.59615 7.0392 6.24744 6.97937C5.89873 6.91955 5.5824 6.73837 5.35436 6.46787C5.12631 6.19737 5.00124 5.85497 5.00124 5.50117C5.00124 5.14737 5.12631 4.80496 5.35436 4.53447C5.5824 4.26397 5.89873 4.08279 6.24744 4.02296C6.59615 3.96314 6.95478 4.02851 7.25996 4.20752C7.56513 4.38654 7.79719 4.66767 7.91512 5.00123H8.50006ZM7.00023 5.50117C7.00023 5.36858 6.94755 5.24142 6.85379 5.14766C6.76004 5.05391 6.63287 5.00123 6.50028 5.00123C6.36769 5.00123 6.24053 5.05391 6.14677 5.14766C6.05301 5.24142 6.00034 5.36858 6.00034 5.50117C6.00034 5.63376 6.05301 5.76092 6.14677 5.85468C6.24053 5.94843 6.36769 6.0011 6.50028 6.0011C6.63287 6.0011 6.76004 5.94843 6.85379 5.85468C6.94755 5.76092 7.00023 5.63376 7.00023 5.50117ZM6.50028 12.0003C6.63287 12.0003 6.76004 11.9476 6.85379 11.8539C6.94755 11.7601 7.00023 11.633 7.00023 11.5004C7.00023 11.3678 6.94755 11.2406 6.85379 11.1469C6.76004 11.0531 6.63287 11.0005 6.50028 11.0005C6.36769 11.0005 6.24053 11.0531 6.14677 11.1469C6.05301 11.2406 6.00034 11.3678 6.00034 11.5004C6.00034 11.633 6.05301 11.7601 6.14677 11.8539C6.24053 11.9476 6.36769 12.0003 6.50028 12.0003ZM12.4996 9.00071C12.6322 9.00071 12.7594 8.94804 12.8531 8.85428C12.9469 8.76053 12.9995 8.63337 12.9995 8.50078C12.9995 8.36819 12.9469 8.24102 12.8531 8.14727C12.7594 8.05351 12.6322 8.00084 12.4996 8.00084C12.367 8.00084 12.2399 8.05351 12.1461 8.14727C12.0523 8.24102 11.9997 8.36819 11.9997 8.50078C11.9997 8.63337 12.0523 8.76053 12.1461 8.85428C12.2399 8.94804 12.367 9.00071 12.4996 9.00071Z"
      fill={DARWIN_NAVY}
      stroke={DARWIN_NAVY}
      stroke-width="0.5"
    />
  </svg>
);
